import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { VoucherGamesListDefaultBox } from "./voucher-games-list.default.box";
import { VoucherGamesListSiBox } from "./voucher-games-list.siCis.box";

export const VoucherGamesListBox = styledByTheme(VoucherGamesListDefaultBox)
    .forSICis(VoucherGamesListSiBox)
    .apply();
